/* eslint-disable sort-keys, max-params */
import API from "../../../shared/modules/API";

export default class BuyItNowAPICLIENT {
  static API_TOKEN = null;

  static API_VERSION = 1;

  static setApiToken (apiToken) {
    this.API_TOKEN = apiToken;
  }

  static validateEmail (email, success, error) {
    return $.post({
      "url": `/api/v${this.API_VERSION}/guest_checkout/validate_email`,
      "data": {email},
      "headers": API.authHeaders(),
      success,
      error
    });
  }

  static verifyAddress (address, success, error) {
    return $.post({
      "url": `/api/v${this.API_VERSION}/condensed_sign_up/verify_address`,
      "data": {"contact": address},
      "headers": API.authHeaders(),
      success (response) {
        success(response);
      },
      error
    });
  }

  static createContact (contactInfo, success, error) {
    return $.post({
      "url": `/api/v${this.API_VERSION}/guest_checkout/create_contact`,
      "data": {"contact": this.formatContactParams(contactInfo)},
      "headers": API.authHeaders(),
      success (response) {
        success(response);
      },
      error
    });
  }

  static placeOrder (orderInfo, success, error) {
    const {
      captchaToken,
      contactId,
      productDescriptorId,
      recurlyToken,
      queryParams
    } = orderInfo;

    return $.post({
      "url": `/api/v${this.API_VERSION}/guest_checkout/place_order`,
      "data": {
        "captcha_token": captchaToken,
        "contact_id": contactId,
        "product_descriptor_id": productDescriptorId,
        "recurly_token": recurlyToken,
        "query_params": queryParams
      },
      "headers": API.authHeaders(),
      success (response) {
        success(response);
      },
      error
    });
  }

  static formatContactParams (contactParams) {
    return {
      "existing_customer_attempt": contactParams.attemptedExistingEmail,
      "first_name": contactParams.firstName,
      "last_name": contactParams.lastName,
      "street_address_1": contactParams.streetAddress,
      "street_address_2": contactParams.unitNumber,
      "city": contactParams.city,
      "state": contactParams.state,
      "zip": contactParams.zipCode,
      "phone": contactParams.phoneNumber,
      "email": contactParams.emailAddress
    };
  }
}
